import { ReactNode } from 'react';

import { type DataTableColumnDef } from '@column/ui';

export const getColumnVisibility = <T>(columns: DataTableColumnDef<T>[], visibleColumns: string[] | undefined) => {
  return columns.reduce(
    (acc, column) => {
      acc[column.accessor as string] = visibleColumns?.includes(column.accessor as string) ?? true;
      return acc;
    },
    {} as Record<string, boolean>
  );
};

export const withAmountFooter = <T>(columns: DataTableColumnDef<T>[], footer: ReactNode): DataTableColumnDef<T>[] =>
  columns.map((column) => (column.accessor === 'amount' ? { ...column, footer } : column));

// Unfilled header and a lighter footer than the grid variant's default.
export const TEMPLATE_TABLE_CLASS_NAME =
  '[--data-table-head-bg:var(--color-background)] [--data-table-foot-bg:color-mix(in_oklab,var(--color-muted)_25%,var(--color-background))]';
